import { useCallback, useEffect, useState } from "react";

import {

  calcSparklineChangePercent,

  getMarketSparkline,

  getStablesApiErrorMessage,

  mapMarketSparkline,

  MARKET_SPARKLINE_DEFAULT_WINDOW,

} from "../Services/stablesApi";



const EMPTY_HISTORY = {

  labels: [],

  values: [],

  changePercent: 0,

  period: MARKET_SPARKLINE_DEFAULT_WINDOW,

};



const withDerivedChangePercent = (history) => {

  const changePercent = Number(history.changePercent) || 0;

  if (changePercent !== 0) return history;



  const values = history.values ?? [];

  if (values.length < 2) return history;



  return {

    ...history,

    changePercent: calcSparklineChangePercent(values),

  };

};



/** FoxBit sparkline via GET /v1/stables/markets/sparkline. */

export const useStablesPriceHistory = (assetId, window = MARKET_SPARKLINE_DEFAULT_WINDOW) => {

  const [history, setHistory] = useState(EMPTY_HISTORY);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);



  const load = useCallback(async () => {

    const normalizedAsset = String(assetId || "").trim().toLowerCase();

    if (!normalizedAsset) return;

    setLoading(true);

    setError(null);



    try {

      const payload = await getMarketSparkline({

        assets: normalizedAsset,

        window,

      });

      const result = mapMarketSparkline(payload, normalizedAsset);

      if (!result.values?.length) throw new Error("Empty sparkline");



      setHistory(withDerivedChangePercent(result));

    } catch (err) {

      setHistory(EMPTY_HISTORY);

      setError(getStablesApiErrorMessage(err, "Erro ao carregar gráfico."));

    } finally {

      setLoading(false);

    }

  }, [assetId, window]);



  useEffect(() => {

    load();

  }, [load]);



  return { history, loading, error, reload: load };

};

